import React, { ReactNode } from "react";
import packageJson from "../../../../../package.json";
import { persister } from "src/providers/queryClient";
import * as Sentry from "@sentry/react";

type Props = { children: ReactNode };
type State = { hasError: boolean };

class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, errorInfo: React.ErrorInfo) {
    Sentry.captureException(error, {
      tags: { section: "react", boundary: "InnerErrorBoundary" },
      extra: { errorInfo },
    });

    const storedVersion = localStorage.getItem("version");

    if (packageJson.version !== storedVersion) {
      localStorage.setItem("version", packageJson.version);
      persister.removeClient();
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return <div>An error has occurred. Our team has been notified.</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
